import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SearchRounded } from '@mui/icons-material';

const Root = styled(TextField)(({ theme }) => ({
	borderRadius: '20px',
	flex: 1,
	[theme.breakpoints.down('sm')]: {
		width: '100%'
	}
}));

const SearchIcon = styled(SearchRounded)(({ theme }) => ({
	width: '18px',
	height: '18px',
	color: theme.palette.text.tertiary
}));

function SearchBar({ value, setValue, ...props }) {
	return (
		<Root
			value={value}
			onChange={(e) => setValue(e?.target?.value)}
			placeholder="Search Galleries"
			InputProps={{
				sx: { borderRadius: '20px', fontSize: '0.9rem' },
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon />
					</InputAdornment>
				)
			}}
			inputProps={{
				sx: {
					height: '36.5px',
					padding: '0 0px'
				}
			}}
			{...props}
		/>
	);
}

export default SearchBar;
